/* eslint-disable react-hooks/exhaustive-deps */
import { useLang } from 'hooks/lang';

import { actions, Office } from 'entities';

import { Modal, Button, Row, LabeledInput } from 'components/Blocks';

import { useFormControl } from 'hooks';

interface ServiceFormProps {
  children?: never;
  close: () => void;
  office: Office | null;
  save: (data: Office) => void;
}

function OfficeForm({ close, save, office }: ServiceFormProps): JSX.Element {
  const { t } = useLang();

  const { state, handleChange } = useFormControl(office ?? ({} as Office), { watch: true });

  const createOffice = actions.offices.createOffice.use({
    onSuccess: (mutatedOffice) => {
      save(mutatedOffice);

      close();
    },
  });

  const updateOffice = actions.offices.updateOffice.use({
    onSuccess: (mutatedOffice) => {
      save(mutatedOffice);

      close();
    },
  });

  const loading = createOffice.loading || updateOffice.loading;

  const handleSaveClick = async (): Promise<void> => {
    const isUpdate = !!office?.id;

    const mutation = isUpdate ? updateOffice : createOffice;

    mutation.execute(state);
  };

  return (
    <Modal
      isOpen={!!office}
      close={close}
      width="min(80vw, 450px)"
      title={(office?.id ? t('edit-office') : t('create-office')) as string}
    >
      <span className="spacer" />

      <LabeledInput
        required
        name="name"
        label={t('name')}
        value={state.name || ''}
        onChange={handleChange}
      />

      <LabeledInput
        required
        name="address"
        label={t('address')}
        value={state.address || ''}
        onChange={handleChange}
      />

      <LabeledInput
        required
        name="city"
        label={t('city')}
        value={state.city || ''}
        onChange={handleChange}
      />

      <LabeledInput
        required
        name="state"
        label={t('state')}
        value={state.state || ''}
        onChange={handleChange}
      />

      <LabeledInput
        required
        name="country"
        label={t('country')}
        value={state.country || ''}
        onChange={handleChange}
      />

      <span className="spacer" />

      <Row justifyContent="space-between">
        <Button variant="outlined" onClick={close}>
          {t('close')}
        </Button>

        <Button onClick={handleSaveClick} loading={loading}>
          {t('save')}
        </Button>
      </Row>
    </Modal>
  );
}

export default OfficeForm;
